import { render } from "./CoursesPage.vue?vue&type=template&id=7159c54d&ts=true"
import script from "./CoursesPage.vue?vue&type=script&lang=ts"
export * from "./CoursesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__